(function () {
  const nativeFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await nativeFetch.apply(this, args);

    try {
      const url =
        typeof args[0] === 'string'
          ? args[0]
          : args[0]?.url || '';

      const isCartRequest =
        url.includes('/cart/change') ||
        url.includes('/cart/add') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear');

      if (!isCartRequest) {
        return response;
      }

      const cloned = response.clone();
      const data = await cloned.json().catch(() => null);

      if (!data) {
        return response;
      }

      const parser = new DOMParser();

      /*
       * CART DRAWER
       */
      if (data.sections?.['cart-drawer']) {
        const doc = parser.parseFromString(
          data.sections['cart-drawer'],
          'text/html'
        );

        const newDrawer = doc.querySelector('cart-drawer');
        const currentDrawer = document.querySelector('cart-drawer');

        if (newDrawer && currentDrawer) {
          /*
           * Non sostituiamo il componente cart-drawer stesso.
           * In questo modo manteniamo il suo stato e i suoi metodi JS.
           */
          currentDrawer.innerHTML = newDrawer.innerHTML;

          /*
           * Se abbiamo appena aggiunto un prodotto dalla product page,
           * apriamo automaticamente il drawer.
           */
          if (url.includes('/cart/add')) {
            setTimeout(() => {
              if (typeof currentDrawer.open === 'function') {
                currentDrawer.open();
              } else {
                currentDrawer.classList.add('active');
                document.body.classList.add('overflow-hidden');
              }
            }, 50);
          }
        }
      }

      /*
       * CART ICON BUBBLE
       */
      if (data.sections?.['cart-icon-bubble']) {
        const bubbleDoc = parser.parseFromString(
          data.sections['cart-icon-bubble'],
          'text/html'
        );

        const newBubbleSection =
          bubbleDoc.querySelector('#shopify-section-cart-icon-bubble');

        const currentBubbleSection =
          document.querySelector('#shopify-section-cart-icon-bubble');

        if (newBubbleSection && currentBubbleSection) {
          currentBubbleSection.innerHTML =
            newBubbleSection.innerHTML;
        } else {
          /*
           * Fallback per alcuni temi Shrine
           */
          const newBubble =
            bubbleDoc.querySelector('#cart-icon-bubble');

          const currentBubble =
            document.querySelector('#cart-icon-bubble');

          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        }
      }
    } catch (error) {
      console.warn('Haven cart fix:', error);
    }

    return response;
  };
})();